import React from 'react';
import View  from '@widesk-ui/components/View';

type CustomTagProps = {
	children: React.ReactNode;
	color?: string;
	icon?: React.JSX.Element;
	style?: React.CSSProperties;
}

const CustomTag = (props: CustomTagProps) => {
	const { children, color, icon, style } = props;

	return (
		<View
			inline
			bg={color}
			bold
			br={2}
			color="#FFF"
			gapH="xxs"
			noWrap
			py={2}
			px={5}
			row
			style={{
				lineHeight: '20px',
				...style,
			}}
			size={14}
			uppercase
			width="fit-content"
		>
			{icon}
			{children}
		</View>
	);
};

export default CustomTag;